<!--
 * Created on Sat Feb 08 2020
 *
 * Copyright (c) 2020 Vilten,s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Viliam Tencer <vilten@vilten.sk>, Sat Feb 08 2020
-->
<template>
  <div>
    <div class="modal" :class="{'active': teamModalVisible}" id="team-modal">
      <div class="modal-overlay" aria-label="Close" @click="teamModalVisible = false"></div>
      <div class="modal-container">
        <div class="modal-header">
          <button class="btn btn-clear float-right" aria-label="Close" @click="teamModalVisible = false"></button>
          <div class="modal-title h5">{{ $t('ourteam') }}</div>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="columns">
              <!-- content here -->
              <transition-group name="bounce" tag="div">
                <div v-if="curTeam === 1" @click="curTeam++;" class="lang-menu-item column col-12" :key="1">
                  <figure class="avatar">
                    <img src="../assets/vilo.jpg" />
                  </figure>
                  <p>{{ $t('team.viliam') }}</p>
                  <p style="font-size: .8rem; opacity: .75;">{{ $t('team.viliamdesc') }}</p>
                  <p style="font-size: .8rem; opacity: .5; padding: 1rem;">{{ $t('team.viliamdescription') }}</p>
                </div>
                <div v-if="curTeam === 2" @click="curTeam--;" class="lang-menu-item column col-12" :key="2">
                  <figure class="avatar">
                    <img src="../assets/burkie.svg" />
                  </figure>
                  <p>...</p>
                  <p style="font-size: .8rem; opacity: .75;">{{ $t('team.you') }}</p>
                  <p style="font-size: .8rem; opacity: .5; padding: 1rem;">{{ $t('team.youdesc') }}</p>
                </div>
              </transition-group>
              <div class="column col-12">
                <i @click="curTeam = curTeam > 1 ? curTeam - 1 : 2" class="icon icon-back" style="margin-right: 2rem; cursor: pointer;"></i>
                <i @click="curTeam = curTeam < 2 ? curTeam + 1 : 1" class="icon icon-forward" style="margin-left: 2rem; cursor: pointer"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" :class="{'active': galleryModalVisible}" id="team-modal">
      <div class="modal-overlay" aria-label="Close" @click="galleryModalVisible = false"></div>
      <div class="modal-container">
        <div class="modal-header">
          <button class="btn btn-clear float-right" aria-label="Close" @click="galleryModalVisible = false"></button>
          <div class="modal-title h5">{{ $t('gallery') }}</div>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="columns">
              <div class="column col-12">
                <i @click="curGallery = curGallery > 1 ? curGallery - 1 : images.length" class="icon icon-back" style="margin-right: 2rem; cursor: pointer;"></i>
                <i @click="curGallery = curGallery < images.length ? curGallery + 1 : 1" class="icon icon-forward" style="margin-left: 2rem; cursor: pointer"></i>
              </div>
              <!-- content here -->
              <div @click="curGallery = curGallery < images.length ? curGallery + 1 : 1" v-for="index in images.length" class="column col-12" :key="index">
                <transition-group tag="div" name="bounce">
                  <div v-if="curGallery === index" :key="index">
                    <p style="font-size: .8rem; opacity: .5; padding: 1rem;">{{ $t('gallery.item' + index) }}</p>
                    <img :src="images[index - 1]" style="width: 100%;" />
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-lg" :class="{'active': mobileMenuVisible}" id="lang-modal">
      <div class="modal-overlay" aria-label="Close" @click="langModalVisible = false">
        <div class="hamburger" @click="mobileMenuVisible = false">
          <i class="icon icon-back"></i>
        </div>
      </div>
      <div class="modal-container">
        <div class="modal-header">
          <img :src="images[images.length - 1]" style="width: 8rem; margin-bottom: 2rem;"/>
          <div class="modal-title h6">{{ $t('chooseMenu') }}</div>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="columns">
              <!-- content here -->
              <div @click="mobileMenuVisible = false; scrollTo('/')" class="mobile-menu-item column col-12">
                {{ $t('menu.home') }}
              </div>
              <div @click="mobileMenuVisible = false; scrollTo('#mob-about')" class="mobile-menu-item column col-12">
                {{ $t('menu.about') }}
              </div>
              <div @click="mobileMenuVisible = false; scrollTo('#mob-gallery')" class="mobile-menu-item column col-12">
                {{ $t('menu.gallery') }}
              </div>
              <div @click="mobileMenuVisible = false; scrollTo('#mob-team')" class="mobile-menu-item column col-12">
                {{ $t('menu.team') }}
              </div>
              <div @click="mobileMenuVisible = false; scrollTo('#mob-contact')" class="mobile-menu-item column col-12">
                {{ $t('menu.contact') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-sm" :class="{'active': langModalVisible}" id="lang-modal">
      <div class="modal-overlay" aria-label="Close" @click="langModalVisible = false"></div>
      <div class="modal-container">
        <div class="modal-header">
          <button class="btn btn-clear float-right" aria-label="Close" @click="langModalVisible = false"></button>
          <div class="modal-title h5">{{ $t('chooselang') }}</div>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="columns">
              <!-- content here -->
              <div @click="lang = 'gb'; langModalVisible = false; changeLocale('gb')" class="lang-menu-item column col-6">
                <flag iso="gb" />
                <span style="margin-left: 1rem;">English</span>
              </div>
              <div @click="lang = 'sk'; langModalVisible = false; changeLocale('sk')" class="lang-menu-item column col-6">
                <flag iso="sk" />
                <span style="margin-left: 1rem;">Slovensky</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" :class="{'active': aboutModalVisible}" id="about-modal">
      <div class="modal-overlay" aria-label="Close" @click="aboutModalVisible = false"></div>
      <div class="modal-container">
        <div class="modal-header">
          <button class="btn btn-clear float-right" aria-label="Close" @click="aboutModalVisible = false"></button>
          <div class="modal-title h5">{{ $t('about.title') }}</div>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="columns">
              <div class="lang-menu-item column col-12">
                <img :src="images[images.length - 1]" style="width: 70%; margin: 1rem 0;"/>
              </div>
              <div class="lang-menu-item column col-12">
                <p v-html="$t('about.content1')"></p>
              </div>
              <div class="lang-menu-item column col-12">
                <img :src="images[0]" style="width: 70%; margin: 1rem 0;"/>
              </div>
              <div class="lang-menu-item column col-12">
                <p v-html="$t('about.content2')"></p>
              </div>
              <div class="lang-menu-item column col-12">
                <img :src="images[2]" style="width: 70%; margin: 1rem 0;"/>
              </div>
              <div class="lang-menu-item column col-12">
                <p v-html="$t('about.content1')"></p>
              </div>
              <div class="lang-menu-item column col-12">
                <img :src="images[4]" style="width: 70%; margin: 1rem 0;"/>
              </div>
              <div class="lang-menu-item column col-12">
                <p v-html="$t('about.content2')"></p>
              </div>
              <div class="lang-menu-item column col-12">
                <img :src="images[images.length - 1]" style="width: 40%; margin: 2rem 0;"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="divTest" style="position: absolute; left:0; top: 0; height: 1px; z-index: -1000; width: 10rem; opacity: 0;">a</div>
    <div v-if="mobVersion" style="position: relative; width: 100vw; height: 100vh;">
      <div class="lang-menuu-cont-small" @click="langModalVisible = true">
        <flag :iso="lang" class="lang-menu-item" />
        <i class="icon icon-arrow-down"></i>
      </div>
      <div class="hamburger" @click="mobileMenuVisible = true">
        <i class="icon icon-menu"></i>
      </div>
      <div style="margin-top: 3rem;">
          <p style="letter-spacing: 5px;">Viliam Tencer's</p>
          <img :src="images[images.length - 1]" style="width: 80vw; max-width: 20rem;"/>
      </div>
      <div>
          <img :src="images[0]" style="width: 100vw; max-width: 20rem; margin: 2rem 0;"/>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1rem;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,30 0,30" fill="#b9353d"/>
        </svg>
      </div>
      <div style="background-color: #b9353d; margin-top: -7px; padding: 5rem 2rem; color: #fff;">
        <p class="skw-page__description" v-html="$t('page1.content')"></p>
        <div class="skw-page__indie">
          <img src="@/assets/funded_indie.png" />
          <br /><br />{{ $t('commingsoon') }}<br /><br />
        </div>
        <div class="skw-page-soc">
          <a class="tooltip" data-tooltip="facebook" href="https://fb.me/3killers.comics" target="_blank"><i class="socicon-facebook"></i></a>
          <a class="tooltip" data-tooltip="twitter" href="" target="_blank"><i class="socicon-twitter"></i></a>
          <a class="tooltip" data-tooltip="instagram" href="" target="_blank"><i class="socicon-instagram"></i></a>
          <br />{{ $t('joinus') }}
        </div>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1px;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,0 500,30" fill="#b9353d"/>
        </svg>
      </div>
      <div>
          <img :src="images[2]" style="width: 100vw; max-width: 20rem; margin: 4rem 0;"/>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1rem;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,30 0,30" fill="#b9353d"/>
        </svg>
      </div>
      <div id="mob-about" style="background-color: #b9353d; margin-top: -7px; padding: 5rem 2rem; color: #fff;">
        <h2 class="skw-page__heading" style="font-size: 2rem;">{{ $t('page2.title') }}</h2>
        <p class="skw-page__description" v-html="$t('page2.content')"></p>
        <div @click="aboutModalVisible = true" class="skw-page__btn_more">{{ $t('moreinfo') }}</div>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1px;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,0 500,30" fill="#b9353d"/>
        </svg>
      </div>
      <div>
          <img :src="images[4]" style="width: 100vw; max-width: 20rem; margin: 4rem 0;"/>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1rem;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,30 0,30" fill="#b9353d"/>
        </svg>
      </div>
      <div id="mob-gallery" style="background-color: #b9353d; margin-top: -7px; padding: 5rem 2rem; color: #fff;">
        <h2 class="skw-page__heading" style="font-size: 2rem;">{{ $t('page3.title') }}</h2>
        <p class="skw-page__description" v-html="$t('page3.content')"></p>
        <div @click="galleryModalVisible = true" class="skw-page__btn_more">{{ $t('show') }}</div>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1px;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,0 500,30" fill="#b9353d"/>
        </svg>
      </div>
      <div>
          <img :src="images[6]" style="width: 100vw; max-width: 20rem; margin: 4rem 0;"/>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1rem;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,30 0,30" fill="#b9353d"/>
        </svg>
      </div>
      <div id="mob-team" style="background-color: #b9353d; margin-top: -7px; padding: 5rem 2rem; color: #fff;">
        <h2 class="skw-page__heading" style="font-size: 2rem;">{{ $t('page4.title') }}</h2>
        <p class="skw-page__description" v-html="$t('page4.content')"></p>
        <div @click="teamModalVisible = true" class="skw-page__btn_more">{{ $t('moreinfo') }}</div>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1px;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,0 500,30" fill="#b9353d"/>
        </svg>
      </div>
      <div>
          <img :src="images[0]" style="width: 100vw; max-width: 20rem; margin: 4rem 0;"/>
      </div>
      <div style="margin: 0; padding: 0; margin-top: -1rem;">
        <svg viewBox="0 0 500 30" style="width: 100vw;">
          <polygon points="0,0 500,30 0,30" fill="#b9353d"/>
        </svg>
      </div>
      <div id="mob-contact" style="background-color: #b9353d; margin-top: -7px; padding: 5rem 2rem; color: #fff;">
        <h2 class="skw-page__heading" style="font-size: 2rem;">{{ $t('page5.title') }}</h2>
        <p class="skw-page__description" v-html="$t('page5.content')"></p>
        <div class="skw-page__description-soc">
          <a class="tooltip" data-tooltip="facebook" href="https://www.facebook.com/viliam.tencer" target="_blank"><i class="socicon-facebook"></i></a>
          <a class="tooltip" data-tooltip="devianart" href="https://www.deviantart.com/vilten" target="_blank"><i class="socicon-deviantart"></i></a>
          <a class="tooltip" data-tooltip="instagram" href="https://www.instagram.com/viliamtencer/" target="_blank"><i class="socicon-instagram"></i></a>
        </div>
      </div>
    </div>
    <div v-if="!mobVersion" v-touch:swipe="swipeHandler" class="skw-pages">
      <div class="menuu-cont">
        <div :class="{'menuu-item': curPage % 2 === 1, 'menuu-item-red': curPage % 2 === 0, 'active': curPage === 1, 'inactive': curPage !== 1}" @click="curPage = 1">{{ $t('menu.home') }}</div>
        <div :class="{'menuu-item': curPage % 2 === 1, 'menuu-item-red': curPage % 2 === 0, 'active': curPage === 2, 'inactive': curPage !== 2}" @click="curPage = 2">{{ $t('menu.about') }}</div>
        <div :class="{'menuu-item': curPage % 2 === 1, 'menuu-item-red': curPage % 2 === 0, 'active': curPage === 3, 'inactive': curPage !== 3}" @click="curPage = 3">{{ $t('menu.gallery') }}</div>
        <div :class="{'menuu-item': curPage % 2 === 1, 'menuu-item-red': curPage % 2 === 0, 'active': curPage === 4, 'inactive': curPage !== 4}" @click="curPage = 4">{{ $t('menu.team') }}</div>
        <div :class="{'menuu-item': curPage % 2 === 1, 'menuu-item-red': curPage % 2 === 0, 'active': curPage === 5, 'inactive': curPage !== 5}" @click="curPage = 5">{{ $t('menu.contact') }}</div>
      </div>
      <div class="lang-menuu-cont" @click="langModalVisible = true">
        <flag :iso="lang" class="lang-menu-item" />
        <i class="icon icon-arrow-down"></i>
      </div>
      <div class="skw-page skw-page-1" :class="{'active': curPage === 1, 'inactive': curPage !== 1}">
        <div class="skw-page__half skw-page__half--left">
          <div class="skw-page__skewed">
            <div class="skw-page__content">
              <div class="skw-page-created" style="color: black;" v-html="$t('copyright')">
              </div>
            </div>
          </div>
        </div>
        <div class="skw-page__half skw-page__half--right">
          <div class="skw-page__skewed">
            <div class="skw-page__content">
              <h2 class="skw-page__heading">{{ $t('page1.title') }}</h2>
              <p class="skw-page__description" v-html="$t('page1.content')"></p>
              <div class="skw-page__indie">
                <img src="@/assets/funded_indie.png" />
                <br />{{ $t('commingsoon') }}
              </div>
              <div class="skw-page-soc">
                <a class="tooltip" data-tooltip="facebook" href="https://fb.me/3killers.comics" target="_blank"><i class="socicon-facebook"></i></a>
                <a class="tooltip" data-tooltip="twitter" href="" target="_blank"><i class="socicon-twitter"></i></a>
                <a class="tooltip" data-tooltip="instagram" href="" target="_blank"><i class="socicon-instagram"></i></a>
                <br />{{ $t('joinus') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="skw-page skw-page-2" :class="{'active': curPage === 2, 'inactive': curPage !== 2}">
        <div class="skw-page__half skw-page__half--left">
          <div class="skw-page__skewed">
            <div class="skw-page__content">
              <h2 class="skw-page__heading">{{ $t('page2.title') }}</h2>
              <p class="skw-page__description" v-html="$t('page2.content')"></p>
              <div @click="aboutModalVisible = true" class="skw-page__btn_more">{{ $t('moreinfo') }}</div>
            </div>
          </div>
        </div>
        <div class="skw-page__half skw-page__half--right">
          <div class="skw-page__skewed">
            <div class="skw-page__content"></div>
          </div>
        </div>
      </div>
      <div class="skw-page skw-page-3" :class="{'active': curPage === 3, 'inactive': curPage !== 3}">
        <div class="skw-page__half skw-page__half--left">
          <div class="skw-page__skewed">
            <div class="skw-page__content"></div>
          </div>
        </div>
        <div class="skw-page__half skw-page__half--right">
          <div class="skw-page__skewed">
            <div class="skw-page__content">
              <h2 class="skw-page__heading">{{ $t('page3.title') }}</h2>
              <p class="skw-page__description" v-html="$t('page3.content')"></p>
              <div @click="galleryModalVisible = true" class="skw-page__btn_more">{{ $t('show') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="skw-page skw-page-4" :class="{'active': curPage === 4, 'inactive': curPage !== 4}">
        <div class="skw-page__half skw-page__half--left">
          <div class="skw-page__skewed">
            <div class="skw-page__content">
              <h2 class="skw-page__heading">{{ $t('page4.title') }}</h2>
              <p class="skw-page__description" v-html="$t('page4.content')"></p>
              <div @click="teamModalVisible = true" class="skw-page__btn_more">{{ $t('moreinfo') }}</div>
            </div>
          </div>
        </div>
        <div class="skw-page__half skw-page__half--right">
          <div class="skw-page__skewed">
            <div class="skw-page__content"></div>
          </div>
        </div>
      </div>
      <div class="skw-page skw-page-5" :class="{'active': curPage === 5, 'inactive': curPage !== 5}">
        <div class="skw-page__half skw-page__half--left">
          <div class="skw-page__skewed">
            <div class="skw-page__content"></div>
          </div>
        </div>
        <div class="skw-page__half skw-page__half--right">
          <div class="skw-page__skewed">
            <div class="skw-page__content">
              <h2 class="skw-page__heading">{{ $t('page5.title') }}</h2>
              <p class="skw-page__description" v-html="$t('page5.content')"></p>
              <div class="skw-page__description-soc">
                <a class="tooltip" data-tooltip="facebook" href="https://www.facebook.com/viliam.tencer" target="_blank"><i class="socicon-facebook"></i></a>
                <a class="tooltip" data-tooltip="devianart" href="https://www.deviantart.com/vilten" target="_blank"><i class="socicon-deviantart"></i></a>
                <a class="tooltip" data-tooltip="instagram" href="https://www.instagram.com/viliamtencer/" target="_blank"><i class="socicon-instagram"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data: function () {
    return {
      mobileMenuVisible: false,
      langModalVisible: false,
      teamModalVisible: false,
      galleryModalVisible: false,
      aboutModalVisible: false,
      curPage: 1,
      mobWidthRem: 60,
      numOfPages: 5,
      animTime: 1300,
      scrolling: false,
      pgPrefix: '.skw-page-',
      mobVersion: true,
      lang: 'gb',
      curTeam: 1,
      curGallery: 1,
      images: [
        '/gallery/book1.jpg',
        '/gallery/3k-01.png',
        '/gallery/book2.jpg',
        '/gallery/3k-02.png',
        '/gallery/book3.jpg',
        '/gallery/3k-03.png',
        '/gallery/book4.jpg',
        '/gallery/3k-04.png',
        '/gallery/3killers.com.png'
      ]
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.resize)
    window.addEventListener('load', this.resize)
    window.addEventListener('mousewheel', this.wheel)
    window.addEventListener('keydown', this.keyPress)
    if (this.$cookies.get('locale')) {
      this.changeLocale(this.$cookies.get('locale'))
      this.lang = this.$cookies.get('locale') === 'en' ? 'gb' : this.$cookies.get('locale')
    } else {
      this.lang = 'gb'
    }
  },
  methods: {
    scrollTo (hash) {
      location.href = hash
    },
    resize (event) {
      const mobWidth = this.mobWidthRem * this.$refs.divTest.clientWidth / 10
      const actualWidth = event.srcElement.innerWidth || event.currentTarget.innerWidth
      this.mobVersion = mobWidth > actualWidth
    },
    movingSwipe (event) {
      if (!event.touches) return
      this.$refs.movv.style.setProperty('--x', event.touches[0].screenX - this.swipeX)
      this.$refs.movv.style.transitionDuration = '0s'
    },
    startSwipe (event) {
      if (!event.touches) return
      this.swipeX = event.touches[0].screenX
    },
    endSwipe (direction, event) {
      this.swipeX = 0
      this.$refs.movv.style.setProperty('--x', 0)
      this.$refs.movv.style.transitionDuration = '500ms'
    },
    swipeHandler (direction) {
      if (this.scrolling || this.mobileMenuVisible) return
      if (this.galleryModalVisible || this.teamModalVisible || this.aboutModalVisible) return
      if (direction === 'top') {
        this.navigateDown()
      } else if (direction === 'bottom') {
        this.navigateUp()
      }
    },
    wheel: function (e) {
      if (this.scrolling || this.mobileMenuVisible) return
      if (this.galleryModalVisible || this.teamModalVisible || this.aboutModalVisible) return
      if (e.wheelDelta > 0 || e.detail < 0) {
        this.navigateUp()
      } else {
        this.navigateDown()
      }
    },
    keyPress: function (e) {
      if (this.scrolling || this.mobileMenuVisible) return
      if (this.teamModalVisible || this.aboutModalVisible) return
      if (this.galleryModalVisible) {
        if (e.which === 38) {
          this.curGallery = this.curGallery > 1 ? this.curGallery - 1 : this.images.length
        } else if (e.which === 37) {
          this.curGallery = this.curGallery > 1 ? this.curGallery - 1 : this.images.length
        } else if (e.which === 39) {
          this.curGallery = this.curGallery < this.images.length ? this.curGallery + 1 : 1
        } else if (e.which === 40) {
          this.curGallery = this.curGallery < this.images.length ? this.curGallery + 1 : 1
        }
        return
      }
      if (e.which === 38) {
        this.navigateUp()
      } else if (e.which === 37) {
        this.navigateUp()
      } else if (e.which === 39) {
        this.navigateDown()
      } else if (e.which === 40) {
        this.navigateDown()
      }
    },
    pagination: function () {
      if (this.galleryModalVisible || this.teamModalVisible || this.aboutModalVisible) return
      this.scrolling = true
      setTimeout(() => {
        this.scrolling = false
      }, this.animTime)
    },
    navigateUp: function () {
      if (this.curPage === 1) return
      this.curPage--
      this.pagination()
    },
    navigateDown: function () {
      if (this.curPage === this.numOfPages) return
      this.curPage++
      this.pagination()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
*, *:before, *:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
$openSans: 'Open Sans', Helvetica, Arial, sans-serif;
body {
  background: #15181A;
  font-family: $openSans;
  margin: 0;
  padding: 0;
}

.skw-pages {
  overflow: hidden;
  position: relative;
  height: 100vh;
}

.hamburger {
  position: relative;
  width: 100vw;
  text-align: left;
  padding: .5rem 1rem;
  font-size: 1rem;

  i {
    cursor: pointer;
  }
  i:active {
    color: #b9353d;
  }
}

.skw-page__description {
  a {
    color: #fff !important;
  }
}

.mobile-menu-item {
  margin-bottom: .5rem;
  cursor: pointer;
}
.mobile-menu-item:active {
  color: #fff;
  background-color: #00000090;
}

.lang-menuu-cont-small {
  position: absolute;
  right: .5rem;
  top: .5rem;
  color: #000;
  z-index: 1;
  cursor: pointer;
  background-color: #00000050;
  border-radius: 1rem;
  padding: .25rem .5rem;

  span {
    width: 1rem;
    height: 1rem;
  }

  i {
    color: #fff;
    margin-left: .25rem;
  }
}

.lang-menuu-cont {
  position: absolute;
  right: 1rem;
  top: 1rem;
  color: #000;
  z-index: 1;
  cursor: pointer;
  background-color: #00000050;
  border-radius: 2rem;
  padding: .25rem .75rem;

  span {
    width: 1.5rem;
    height: 1.5rem;
  }

  i {
    color: #fff;
    margin-left: .5rem;
    margin-top: .5rem;
  }
}

#lang-modal, #team-modal {
  .container {
    font-size: 1rem;
  }

  .lang-menu-item:hover {
    background-color: #b9353d;
    cursor: pointer;
    color: #fff;
  }

  .avatar {
    margin-top: 1rem;
    height: 7rem;
    width: 7rem;
    margin-bottom: .5rem;
    background-color: #ffffff66;
  }
}

.menuu-cont {
  position: absolute;
  color: #fff;
  top: 1rem;
  left: 2rem;
  z-index: 100;

  .menuu-item {
    text-transform: capitalize;
    float: left;
    font-size: 1rem;
    padding: .25rem 1rem;
    margin-left: -1px;
    color: #b9353d;
    background-color: #fff;
    cursor: pointer;
  }

  .menuu-item-red {
    text-transform: capitalize;
    float: left;
    font-size: 1rem;
    padding: .25rem 1rem;
    margin-left: -1px;
    color: #fff;
    background-color: #b9353d;
    cursor: pointer;
  }

  .menuu-item.active {
    border-bottom: 6px solid #b9353d;
  }

  .menuu-item.inactive {
    border-bottom: 6px solid #fff;
  }

  .menuu-item-red.active {
    border-bottom: 6px solid #fff;
  }

  .menuu-item-red.inactive {
    border-bottom: 6px solid #b9353d;
  }
}

$skewDeg: 18deg;
$magicVH: 32.4vh; // this number is magic and depends on skew angle
$scrollTime: 1s;

.skw-page-soc {
  position: relative;
  bottom: 1rem;
  font-size: .7rem;

  i {
    color: #fff;
    font-size: 1.5rem;
    margin: .25rem;
  }
}

.skw-page {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  margin: 0;
  padding: 0;

  .skw-page-created {
    color: #000;
    position: absolute;
    bottom: 1rem;
    font-size: .6rem;
  }

  .skw-page-soc {
    position: absolute;
    bottom: 1rem;
    font-size: .7rem;

    i {
      color: #fff;
      font-size: 1.5rem;
      margin: .25rem;
    }
  }

  &__half {
    position: absolute;
    top: 0;
    width: 50%;
    height: 100vh;
    transition: transform $scrollTime;

    &--left {
      left: 0;
      transform: translate3d(-$magicVH, 100%, 0);
        }

    &--right {
      left: 50%;
      transform: translate3d($magicVH, -100%, 0);
    }

    .skw-page.active & {
      transform: translate3d(0,0,0);
    }
  }

  &__skewed {
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 140%;
    height: 100%;
    transform: skewX($skewDeg * -1);
    background: #fff;

    .skw-page__half--left & {
      left: -40%;
    }
    .skw-page__half--right & {
      right: -40%;
    }
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column wrap;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0 30%;
    color: #fff;
    transform: skewX($skewDeg);
    transition: transform $scrollTime, opacity $scrollTime;
    background-size: cover;

    .skw-page__half--left & {
      padding-left: 35%;
      padding-right: 35%;
      transform-origin: 100% 0;
    }
    .skw-page__half--right & {
      padding-left: 35%;
      padding-right: 35%;
      transform-origin: 0 100%;
    }

    .skw-page.inactive & {
      opacity: 0.5;
      transform: skewX($skewDeg) scale(0.95);
    }
  }

  &__heading {
    margin-bottom: 1rem;
    text-transform: uppercase;
    font-size: 2.5rem;
    text-align: center;
    font-family: 'Archivo Black', Helvetica, Arial, sans-serif;
  }

  &__description {
    font-size: .9rem;
    text-align: center;

  }

  &__btn_more {
    background-color: #ffffff50;
    border: 0;
    height: 2.5rem;
    padding: .5rem 1rem;
    border-radius: 1.25rem;
    color: #b9353d;
    text-transform: uppercase;
    font-family: 'Archivo Black', Helvetica, Arial, sans-serif;
    font-size: 1rem;
    margin-top: 2rem;
    cursor: pointer;
  }

  &__btn_more:active {
    background-color: #ffffff90;
  }

  &__description-soc {
    margin-top: 2rem;
    font-size: .7rem;

    i {
      color: #fff;
      font-size: 1.5rem;
      margin: .25rem;
    }
  }

  &__indie {
    margin-top: 2rem;
    img {
      height: 3.5rem;
    }
    img:hover {
      cursor: pointer;
    }
  }

  &__link {
    color: #FFA0A0;
  }

  &-1 {
    .skw-page__half--left .skw-page__content {
      background-image: url('../assets/3killers.com.png');
      background-size: 40%;
      background-position: 50% 50%;
      background-repeat: no-repeat;
    }
    .skw-page__half--right .skw-page__content {
      background: #b9353d;
    }
  }
  &-2 {
    .skw-page__half--left .skw-page__content {
      background: #b9353d;
    }
    .skw-page__half--right .skw-page__content {
      background-image: url('/gallery/book1.jpg');
      background-size: 80%;
      background-position: 50% 50%;
      background-repeat: no-repeat;
    }
  }
  &-3 {
    .skw-page__half--left .skw-page__content {
      background-image: url('/gallery/book2.jpg');
      background-size: 80%;
      background-position: 50% 50%;
      background-repeat: no-repeat;
    }
    .skw-page__half--right .skw-page__content {
      background: #b9353d;
    }
  }
  &-4 {
    .skw-page__half--left .skw-page__content {
      background: #b9353d;
    }
    .skw-page__half--right .skw-page__content {
      background-image: url('/gallery/book3.jpg');
      background-size: 80%;
      background-position: 50% 50%;
      background-repeat: no-repeat;
    }
  }
  &-5 {
    .skw-page__half--left .skw-page__content {
      background-image: url('/gallery/3k-col.jpg');
      background-size: 60%;
      background-position: 50% 50%;
      background-repeat: repeat;
    }
    .skw-page__half--right .skw-page__content {
      background: #b9353d;
    }
  }
}
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in 0s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(.8);
  }
  100% {
    transform: scale(1);
  }
}
</style>
